import valid from 'card-validator';
import { binAlelo, binElo } from '../../utils/bins';

export const validateCreditCard = (value) => {
  const creditCardNumber = value.replace('_', '');
  const numberValidation = valid.number(creditCardNumber);
  return numberValidation.isValid;
};

export const validateCreditCardFlag = (value) => {
  const newValue = value || '';
  const number = newValue.replace(/[^\d]/g, '');
  const numberValidation = valid.number(number);
  if (isElo(number)) {
    return 'elo';
  }
  if (numberValidation.isPotentiallyValid) {
    if (isVisa(number)) {
      return 'visa';
    }
    if (isAlelo(number)) {
      return 'alelo';
    }
    if (
      (numberValidation.card && numberValidation.card.type === 'mastercard') ||
      (numberValidation.card && numberValidation.card.type === 'master-card')
    ) {
      return 'master';
    }
    if (
      numberValidation.card &&
      numberValidation.card.type === 'american-express'
    ) {
      return 'amex';
    }
    if (numberValidation.card && numberValidation.card.type) {
      return numberValidation.card.type;
    }
  } else return undefined;
};

export const isAlelo = (numbers) => {
  const stripedNumbers = numbers.replace(' ', '');
  const bin = stripedNumbers.slice(0, 6);
  return binAlelo.indexOf(bin) !== -1;
};

export const isVisa = (number) => {
  const specificVisaBins = ['589916', '406655'];
  if (number) {
    return specificVisaBins.includes(number.match(/\d+/g).join([]).slice(0, 6));
  }
  return false;
};

/**
 * This method is using a bin table from Elo Developers Page.
 * @param numbers (string | int)
 * @see doc https://dev.elo.com.br/apis/tabela-de-bins?lng=pt
 */
export const isElo = (cardNum) => {
  if (!cardNum) {
    return undefined;
  }
  const bin = cardNum.slice(0, 6);
  const hasBin = binElo.indexOf(bin) !== -1;
  return hasBin;
};

export const BANKS = {
  BB: 'BB',
  BRADESCO: 'BRADESCO',
  ORIGINAL: 'ORIGINAL',
};

const BANKS_DIGIT_WEIGHTS = {
  BB: [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5, 6, 7, 8, 9],
  BRADESCO: [2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7],
  ORIGINAL: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
};

export function sumDigits(value) {
  let sum = 0;
  while (value) {
    sum += value % 10;
    value = Math.floor(value / 10);
  }
  return sum;
}

export function validateItauDVAccount(agencyAccount) {
  const digitsWeight = [2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1];

  if (agencyAccount.length > 16) {
    throw new Error(
      'Número da Conta não suportada pela função de Cálculo de Dígito Verificador!',
    );
  }

  let sumCalculation = 0;
  let digitIndex = 0;

  for (var index = agencyAccount.length - 1; index >= 0; index--) {
    let currentCalculation =
      parseInt(agencyAccount[index]) * digitsWeight[digitIndex];
    sumCalculation +=
      currentCalculation > 9
        ? sumDigits(currentCalculation)
        : currentCalculation;

    digitIndex++;
  }
  return sumCalculation % 10 === 0 ? 0 : 10 - (sumCalculation % 10);
}

export function validateDVAccount(account, bankName) {
  const digitsWeight = BANKS_DIGIT_WEIGHTS[bankName];

  if (!digitsWeight) {
    throw new Error('Banco inválido!');
  }

  if (account.length > 16) {
    throw new Error(
      'Número da Conta não suportada pela função de Cálculo de Dígito Verificador!',
    );
  }

  let sumCalculation = 0;
  let digitIndex = 0;

  for (var index = account.length - 1; index >= 0; index--) {
    sumCalculation += parseInt(account[index]) * digitsWeight[digitIndex];
    digitIndex++;
  }
  let resultedDigit = (sumCalculation * 10) % 11;

  return resultedDigit >= 10 ? 0 : resultedDigit;
}
